import axios from "axios";
import { serviceBaseUrl } from "./constants";

export const getPlayerLeaderboard = async (matchId: string) => {
  try {
    const response = await axios.get(
      `${serviceBaseUrl}/playerLeaderboard/${matchId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching leaderboard for match.:", error);
    throw error;
  }
};


export const getSeasonPlayerLeaderboard = async (seasonId: string) => {
  try {
    const response = await axios.get(
      `${serviceBaseUrl}/seasonPlayerLeaderboard/${seasonId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching leaderboard for season:", error);
    throw error;
  }
};